<!-- close button -->
<div class="row">
    <div class="col-12">
        <button mat-dialog-close class="close-button" tabindex="-1"></button>
    </div>
</div>

<!-- dialog content -->
<mat-dialog-content>

    <!-- prevent exiting -->
    <h1>
        Don't leave now!
    </h1>

    <!-- content -->
    <div class="row">
        <div class="col-8">
            <h2>
                You have come this far, and only a few more questions are left.<br /><br />

                <strong>Your participation is crucial to my research, and only completed questionnaires mean good results!</strong><br /><br />

                Select "Continue later" or copy the current page's link, and complete the questionnaire later.<br /><br />

                I really appreciate your contribution.<br /><br /><strong>Thank you.</strong><br />

                <!--<img src="/images/man.png" width="30%" />-->
                <!--Don't forget you
                receive the assessment report tailored to your organization once you have completed the questionnaire.<br /><br />-->


            </h2>
        </div>
        <div class="col-4"><img src="/images/man.png" data-full_image_src="/images/man.png" /></div>
    </div>

</mat-dialog-content>
